import { useContext } from "react";
import CountryContext from "../../context/Config/ConfigContext";

const CountryData = () => useContext(CountryContext);

export default CountryData;
